import React from "react";
import classNames from "classnames";
import { IconProps, IconDimensions } from "../../types";
import { getIconDimensions } from "../../../utils/icon-utils";

export const IconEyeEmpty = ({
  title,
  titleId,
  color,
  className: classNameProp,
  size,
  height,
  width,
  ...restProps
}: IconProps) => {
  const className = classNames(
    {
      [`text-${color}`]: color !== undefined,
    },
    classNameProp
  );

  const defaultDimensions: IconDimensions = {
    height: 24,
    width: 24,
  };
  const props = {
    className,
    ...getIconDimensions(size, width, height, defaultDimensions?.width, defaultDimensions?.height),
    ...restProps,
  };

  return (
    <svg fill="currentcolor" viewBox="0 0 24 24" {...props}>
      {title ? <title id={titleId}>{title}</title> : null}
      <path
        fillRule="evenodd"
        d="M12 5c2.298 0 4.707 1.088 6.982 3.104 1.258 1.115 2.206 2.24 2.743 3.012a1.56 1.56 0 01.001 1.767c-.538.774-1.486 1.898-2.744 3.013C16.707 17.912 14.298 19 12 19s-4.707-1.088-6.982-3.104c-1.257-1.115-2.2-2.23-2.743-3.012a1.56 1.56 0 010-1.768c.544-.78 1.486-1.897 2.743-3.012C7.293 6.088 9.702 5 12 5zm0 2c-1.76 0-3.72.885-5.655 2.6a17.62 17.62 0 00-2.255 2.422L4.107 12l.21.267.26.316a17.614 17.614 0 001.768 1.816C8.28 16.115 10.24 17 12 17c1.76 0 3.72-.885 5.655-2.6a17.616 17.616 0 002.255-2.422l-.018.021-.208-.266-.26-.316a17.621 17.621 0 00-1.769-1.816C15.72 7.885 13.76 7 12 7zm0 2.25a2.75 2.75 0 110 5.5 2.75 2.75 0 010-5.5z"
      />
    </svg>
  );
};

IconEyeEmpty.displayName = "IconEyeEmpty";
